import type { FC, ReactElement } from 'react'
import { useEffect, useState } from 'react'

import type { InputProps as UIInputProps } from '../Input'
import { Input as UIInput } from '../Input'

export const InputWithValidation: FC<
  Omit<UIInputProps, 'value'> & {
    errorMessage: string | ReactElement
    value: string | number
    validator: (val: string | number) => boolean
  }
> = ({ value, errorMessage, validator = () => true, ...restOfProps }) => {
  const [hasValidatorError, setHasValidatorError] = useState(false)

  useEffect(() => {
    setHasValidatorError(Boolean(value) && !validator(value))
  }, [value])

  const error = hasValidatorError ? errorMessage : undefined

  return <UIInput value={value} customError={error} {...restOfProps} />
}
